import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class OptionPresenter extends EntityPresenter {
  static urn = 'options'
  static key = 'option'

  static navOptions(key = 'options') {
    const routes = {
      options: {
        icon: 'settings',
        pageRoutes: ['option'],
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(OptionPresenter)
